import React from 'react';
import classnames from 'classnames';
import './SwitchBase.scss';
const SwitchBase = ({ activeElement, inactiveElement, isActive, disabled, switchHandle = () => null }) => {
    const content = isActive
        ? activeElement
        : inactiveElement;
    const rootClassNames = classnames({
        'ml-switch': true,
        'ml-switch--disabled': disabled,
    });
    return (<div className={rootClassNames} onClick={switchHandle}>
      <div className="ml-switch__item">
        {content}
      </div>
    </div>);
};
export default SwitchBase;
